import http, { IObjStr, IObjStrNum, IObjStrObj } from '@/utils/http';
import { getLoanInfoBaseResponse, ILoanProductList, userAgreementListParams } from './apiType';
import { propsList } from '@/api/pageLoading';
const prefix = '/ysr-h5-app/web';

export const userAgreementList = (params: userAgreementListParams): Promise<ILoanProductList> =>
  http.post<ILoanProductList>(prefix + '/h5ProtocolControl/getProtocol', params);

/* 获取用户贷款金额与期限 */
export const getLoanInfoBase = (): Promise<getLoanInfoBaseResponse> =>
  http.post<getLoanInfoBaseResponse>(prefix + '/creditConversionControl/getUserCapital');
/**签证*/
export const signContractNew = (par: IObjStr): Promise<void> =>
  http.post<void>(prefix + '/h5ProtocolControl/walletSignContract', par);
/**产品申请*/
export const batchApply = (par: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/creditConversionControl/multiplePushApplyCreditProduct', par);
/**协议埋点*/
export const userProtocol = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/h5ProtocolControl/walletProtocolBuriedPoint', par);
/**留资更新*/
export const applyDataDetailUpdate = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/creditConversionControl/updateUserCapital', par);
/**获取登录凭证*/
export const getVoucher = (): Promise<IObjStr> => http.post<IObjStr>(prefix + '/user/getVoucher');
/**凭证登录接口*/
export const voucherLogin = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/user/voucherLogin', par);
/**返回拦截推荐信贷*/
export const h5CreditRecommendNonCurrent = (par: IObjStrNum): Promise<IObjStr[]> =>
  http.post<IObjStr[]>(prefix + '/creditConversionControl/h5CreditRecommendNonCurrent', par);
/**信贷多次匹配*/
export const h5CreditRecommendMultiple = (par?: IObjStrObj | string): Promise<propsList[]> => {
  if (par) {
    return http.post<propsList[]>(
      prefix + '/creditConversionControl/h5CreditMultiplePushRecommend',
      par as IObjStrObj
    );
  } else {
    return http.post<propsList[]>(
      prefix + '/creditConversionControl/h5CreditMultiplePushRecommend'
    );
  }
};

/**获取信贷滚动数据*/
export const getTopCreditList = (): Promise<string[]> =>
  http.post<string[]>(prefix + '/page/getTopCreditList');

/** 无token 信贷半流程新版采量查询产品 */
export const getNewCreditBuyingProductList = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/creditConversionControl/getNewCreditBuyingProductList', par);

/** 无token 信贷半流程新版采量申请产品 */
export const newCreditBuyingProductApply = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/creditConversionControl/newCreditBuyingProductApply', par);

export const apiBuyingHalfResult = (par: IObjStrNum): Promise<void> =>
  http.post<void>(prefix + '/creditApiBuying/halfResult', par);
